import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {Product} from '@spartacus/core/src/model/product.model';
import {ConfiguratorProductService} from '../../../services/configurator-product.service';
import {DcpError} from '@dcp/configurator';

/**
 * Error-page representing the 'VAL_0304' - 'Upsell not possible' Error
 */
@Component({
  selector: 'dcp-checkout-unavailable',
  templateUrl: './checkout-unavailable.component.html',
  styleUrls: ['./checkout-unavailable.component.scss']
})
export class CheckoutUnavailableComponent implements OnInit {
  displayProduct$: Observable<Product>;
  variantProduct$: Observable<Product>;

  @Input() error: DcpError;

  constructor(
    private configuratorProductService: ConfiguratorProductService,
  ) {
  }

  ngOnInit(): void {
    this.displayProduct$ = this.configuratorProductService.getDisplay$();
    this.variantProduct$ = this.configuratorProductService.getVariant$();
  }
}
